import React, { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { Input } from '@factorialco/f0-react/dist/experimental'
import type { ComplaintsCategoriesQuery } from 'generated/resources/graphql'

import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useUpdateComplaintsCategory } from 'modules/complaints/hooks/useUpdateComplaintsCategory'

interface EditCategoryModalProps {
  category: ComplaintsCategoriesQuery['complaints']['categoriesConnection']['nodes'][0] | null
  open: boolean
  onClose: () => void
}

export const EditCategoryModal = ({ category, open, onClose }: EditCategoryModalProps) => {
  const [categoryName, setCategoryName] = useState('')
  const [loading, setLoading] = useState(false)
  const { updateComplaintsCategory } = useUpdateComplaintsCategory()

  useEffect(() => {
    if (category) {
      setCategoryName(category.name)
    }
  }, [category])

  const handleSubmit = async () => {
    if (!categoryName.trim() || !category) return

    setLoading(true)
    try {
      const result = await updateComplaintsCategory({
        id: category.id,
        name: categoryName.trim(),
      })
      const handledResult = handleResult(result, () => {})

      if (handledResult.success) {
        onClose()
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t(
            'app_store_v2.apps.complaints.settings.categories.save_category_error_message'
          ),
        })
      }
    } finally {
      setLoading(false)
    }
  }

  if (!category) return null

  return (
    <F0Dialog
      isOpen={open}
      onClose={onClose}
      title={i18n.t('app_store_v2.apps.complaints.settings.categories.edit_modal.title')}
      primaryAction={{
        label: loading ? i18n.t('common.saving') : i18n.t('common.save'),
        onClick: handleSubmit,
        disabled: !categoryName.trim() || loading,
        loading: loading,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
        disabled: loading,
      }}
    >
      <Box gap="s12">
        <Input
          label={i18n.t('app_store_v2.apps.complaints.settings.categories.category_name')}
          value={categoryName}
          onChange={(value: string) => setCategoryName(value)}
          placeholder={i18n.t(
            'app_store_v2.apps.complaints.settings.categories.category_name_placeholder'
          )}
        />
      </Box>
    </F0Dialog>
  )
}
